var _userAgentData;
/**
 * How this machine spells its modifier keys, so a shortcut hint matches the keyboard in front of
 * the reader instead of assuming one platform.
 *
 * userAgentData.platform first: navigator.platform is deprecated and frozen, and reports the same
 * value for configurations it can no longer tell apart. Both are read because userAgentData is
 * Chromium only.
 */
const platform = (typeof navigator === 'undefined' ? '' : ((_userAgentData = navigator.userAgentData) === null || _userAgentData === void 0 ? void 0 : _userAgentData.platform) || navigator.platform) || '';
const isApplePlatform = /mac|iphone|ipad|ipod/i.test(platform);

/** Opens the command palette. Ctrl works on a Mac too; this is the label, not the binding. */
export const paletteShortcut = isApplePlatform ? '\u2318K' : 'Ctrl K';

/** Switches the search scope. Option is what the key is called on an Apple keyboard. */
export const scopeShortcut = isApplePlatform ? '\u2325A' : 'Alt+A';